import { useState } from 'react';
import Grid from '@mui/material/Grid';
import DonutChart from '../../components/Charts/DonutChart/DonutChart';
import Filter from '../../components/Filter/Filter';
import dayjs from 'dayjs';
import DataTable from '../../components/DataTable/DataTable';
import DataMap from '../../components/DataMap/DataMap';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {useDashboard} from '../../hooks/useDashboard';
import { totalConsumptionColumns, gatewayInfoColumns, latestPayloadsColumns } from '../../Helpers/dashboardTablesMap';


const Dashboard = () => {
  const [filters, setFilters] = useState({
    fromDate: dayjs().add(-1, "day").startOf("day"),
    toDate: dayjs().startOf("day"),
    fromTime: dayjs().hour(12).minute(0).second(0),
    toTime: dayjs().hour(12).minute(0).second(0),
  });


  const { countDevices, gatewaysInfo, gateways, totalConsumptions, latestPayloads, gatewaysStatus, devicesStates, handleSearchClick } = useDashboard(filters);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title={
              <>
                <Typography>Πλήθος Συσκευών: {countDevices?.all ?? 0}</Typography>
                <Typography>Πλήθος gateways: {gatewaysInfo?.length ?? 0}</Typography>
              </>
            }
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
              <>
                <Typography>Πλήθος Pillars: {countDevices?.pillars ?? 0}</Typography>
                <Typography>Πλήθος Φωτιστικών: {countDevices?.lights ?? 0}</Typography>
                <Typography>Δεδομένα συσκευών LoRaWAN - NEMA: {countDevices?.allNema ?? 0}</Typography>
              </>
                <DonutChart title="Κατάσταση Συσκευών" seriesToRender = {devicesStates} labelsToRender={["Επιτυχής Σύνδεση", "Δεν αποκρίνεται"]} />
              </Grid>
              <Grid item xs={12} sm={6}>
              <Typography>Δεδομένα Gateways τώρα</Typography>
              <DonutChart title="Κατάσταση Συσκευών" seriesToRender = {gatewaysStatus} labelsToRender={["Connected", "Disconnected"]} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <DataTable columns = {totalConsumptionColumns} data = {totalConsumptions}/>
        <Filter filters = {filters} setFilters={setFilters} deviceStateFilters = {false}  onSearch={handleSearchClick}/>
      </Grid>
      <Grid item xs={12}>
        <DataTable columns = {gatewayInfoColumns} data = {gatewaysInfo}/>
      
        <DataMap markers = {gateways} deviceType = {"dashboard"} modalFetcher={null}/>
      </Grid>

      <Grid item xs={12}>
        <DataTable columns = {latestPayloadsColumns} data = {latestPayloads}/>
      </Grid>

    </Grid>

  );
};

export default Dashboard;
